enum LLMReasoningEffort {
  None = 'none',
  Minimal = 'minimal',
  Low = 'low',
  Medium = 'medium',
  High = 'high',
}

enum LLMVerbosity {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
}

export {LLMReasoningEffort, LLMVerbosity};
